module.exports = __webpack_public_path__ + "static/media/OSTR04.517bc07f.jpg";